import { Box } from "@mui/material";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { quoteCreateActions } from "../../../redux/features/quotes/quote-create-advanced";
import { selectStep } from "../../../redux/features/quotes/quote-create-advanced/selectors/navigationSelectors";
import { selectQuoteCreatePayload } from "../../../redux/features/quotes/quote-create-advanced/selectors/quoteCreateSelectors";
import { JobOperationStatus } from "../../jobs2/JobOperationStatus";
import { QuoteCreateSummary } from "./advanced-quote/quote-summary/QuoteCreateSummary";
import { SectorWorkFlowView } from "./advanced-quote/sectorworkflow/view/SectorWorkFlowView";
import { QuoteCreateStepper } from "./advanced-quote/stepper/QuoteCreateStepper";
import { QuoteCreateNextPrev } from "./next-prev/QuoteCreateNextPrev";
import { RootState } from "src/redux/store";

export const QuoteLayout = () => {
  const dispatch = useDispatch();
  const stepQuote = useSelector(selectStep);
  const finalQuote = useSelector(selectQuoteCreatePayload);
  const scrollRef = useRef<HTMLDivElement>(null);
  const alias = useSelector((state: RootState) => state.quoteCreate.sectorWorkflow.alias || "");
  useEffect(() => {
    if (stepQuote === "scheduler") {
      dispatch(quoteCreateActions.setStep("summary"));
    }
  }, [stepQuote, dispatch]);

  useEffect(() => {
    if (stepQuote === "summary") {
      requestAnimationFrame(() => {
        scrollRef.current?.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  }, [stepQuote]);

  const stepComponents = {
    sector: <SectorWorkFlowView />,
    summary: <QuoteCreateSummary summary={finalQuote} />,
    status: <JobOperationStatus />,
  };

  const resolvedStep = stepQuote === "scheduler" ? "summary" : stepQuote;
  const currentComponent = stepComponents[resolvedStep as keyof typeof stepComponents] || <Box sx={{ mt: 4 }}>Unknown step</Box>;

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: "var(--fx-surface-base, #FFFFFF)",
        p: 2,
      }}
    >
      <Box
        ref={scrollRef}
        sx={{
          flex: 1,
          overflowY: "auto",
          pr: 1,
        }}
      >
        <QuoteCreateStepper />

        <Box sx={{ mt: 2 }}>{currentComponent}</Box>
      </Box>

      <Box
        sx={{
          pb: 0.2,
          display: "flex",
          justifyContent: "center",
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
          borderTop: "1px solid var(--fx-surface-border, #E2E8F0)",
        }}
      >
        <QuoteCreateNextPrev />
      </Box>
    </Box>
  );
};
